// extracted by mini-css-extract-plugin
export default {"shipmentTracking":"rf-z","header":"sf-z","orderId":"tf-z","divider":"uf-z","trackingError":"vf-z"};